import { render, staticRenderFns } from "./RateBlock.vue?vue&type=template&id=62e47040&"
import script from "./RateBlock.vue?vue&type=script&lang=js&"
export * from "./RateBlock.vue?vue&type=script&lang=js&"
import style0 from "./RateBlock.vue?vue&type=style&index=0&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports